import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import { get } from '@atlas/core';

import FormMobile from 'common/Form/FormMobile';
import CaptchaContext from 'common/Form/FormWithCaptcha/CaptchaContext';
import useFormCaptchaState from 'common/Form/FormWithCaptcha/useFormCaptchaState';

const FormWithCaptcha = forwardRef(({ additionalValues, formType, onError, ...props }, ref) => {
  const initialCaptchaKey = get(formType, 'optionalParams.captchaKey');
  const initialCaptchaRequired = get(formType, 'optionalParams.captchaRequired');

  const captchaData = useFormCaptchaState(initialCaptchaKey, initialCaptchaRequired, onError);
  const { handleError, input: captchaInput } = captchaData;

  const mergedAdditionalValues = useMemo(
    () => Object.assign(additionalValues ?? {}, { CAPTCHA_INPUT: captchaInput }),
    [additionalValues, captchaInput],
  );

  return (
    <CaptchaContext.Provider value={captchaData}>
      <FormMobile
        {...props}
        additionalValues={mergedAdditionalValues}
        formType={formType}
        onError={handleError}
      />
    </CaptchaContext.Provider>
  );
});

FormWithCaptcha.displayName = 'FormWithCaptcha';

FormWithCaptcha.propTypes = {
  additionalValues: PropTypes.object,
  formType: PropTypes.object,
  onError: PropTypes.func,
};

export default FormWithCaptcha;
